export default __webpack_public_path__ + "static/media/Dashclicks-Expanded.06aa08d0.png";